import { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { constants, Utils } from '../../../../helpers';
import './DriveInfoBlock.scss';
import { publishFirmwareDeviceSetting } from '../shared/PublishDeviceSettings';
import {
  PrimaryButton,
  SiteModal,
  TextBlock,
} from '../../../../components/common';
import { ReactComponent as CheckCircle } from '../../../../assets/images/CheckCircle.svg';
import { ReactComponent as ExclamationCircle } from '../../../../assets/images/ExclamationCircle.svg';
import { ReactComponent as XCircle } from '../../../../assets/images/XCircle.svg';
import { sizeConvertor } from '../../../../helpers/commonUtils';

const DriveInfoBlock = ({
  deviceId,
  deviceInfos,
  updateStore,
  accountId,
  devicePublishId,
  sessionId,
  cgrHubDetails,
}) => {
  const [showFormatDriveModal, setShowFormatDriveModal] = useState(false);
  const [driveDetails, setDriveDetails] = useState(
    cgrHubDetails?.internalDrives,
  );
  const tid = Math.floor(new Date().getTime() / 1000.0);
  const publishPayload = {
    transactionID: tid,
    accountId: accountId,
    deviceId: deviceId,
    hubId: deviceInfos?.gatewayId,
    uuid: sessionId,
    devicePublishId: devicePublishId,
  };
  const capabilityList = deviceInfos?.capDetails?.capabilities;
  //CGR capability start
  const cgrResourceList = Utils.getDeviceSettingResource(12);
  const cgrDriveList = Utils.getCurrentTabProperty(
    capabilityList,
    cgrResourceList[5],
  );
  const driveSlots = parseInt(
    cgrDriveList?.slot.max - cgrDriveList?.slot.min + 1
      ? cgrDriveList?.slot.max - cgrDriveList?.slot.min + 1
      : 0,
  );
  const [formattedDrive, setFormattedDrive] = useState({});
  //CGR capability end

  const formatDriveAction = () => {
    let driveData = cgrHubDetails?.internalDrives?.map((drive) => {
      if (drive.path == formattedDrive?.path) {
        return { ...drive, driveState: 'Formatting' };
      }
      return driveData;
    });
    setDriveDetails(driveData);
    const properties = {
      path: formattedDrive?.path,
      formatDrive: 'true',
    };
    publishFirmwareDeviceSetting(
      properties,
      cgrResourceList[5],
      publishPayload,
      false,
    );
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant',
    });
  }, []);

  const handleFormatDriveAction = (drive) => {
    setFormattedDrive(drive);
    setShowFormatDriveModal(!showFormatDriveModal);
  };

  return (
    <div className="text-start audio-settings-block">
      <div>
        <div className="section-heading mb-2">
          <label>{constants.DRIVE_TAB_DRIVE_MANAGEMENT}</label>
        </div>
        <div>
          <p className="article-link-text">
            {constants.FOR_MORE_INFORMATION}
            <a className="article-link-disabled">{constants.ARTICLE_LINK}</a>
          </p>
        </div>
        {driveSlots && driveSlots != 0
          ? Array(driveSlots)
              .fill(driveSlots)
              .map((drive, index) => (
                <div className="device-info-section">
                  <Row className="settings-block">
                    <Col>
                      <div className="settings-info-block-content">
                        {constants.DRIVE_TEXT} {index + 1}
                      </div>
                    </Col>
                    <Col>
                      {driveDetails?.[index]?.status &&
                      driveDetails?.[index]?.status !==
                        constants.DRIVE_NOT_INSTALLED_STATUS ? (
                        <div className="settings-info-block-content">
                          <div
                            className="format-drive"
                            onClick={() =>
                              handleFormatDriveAction(driveDetails?.[index])
                            }
                          >
                            {constants.FORMAT_DRIVE}
                          </div>
                        </div>
                      ) : (
                        ''
                      )}
                    </Col>
                  </Row>
                  <Row className="settings-block">
                    <Col>
                      <div className="hub-info-block-heading">
                        {constants.DEVICE_INFO_DEVICE_STATUS_TITLE}
                      </div>
                      <div className="hub-info-block-content">
                        {driveDetails?.[index]?.status ==
                          constants.DRIVE_READY_STATUS &&
                        driveDetails?.[index]?.driveState !==
                          constants.DRIVE_FORMATTING_STATUS ? (
                          <CheckCircle
                            size={20}
                            color={getComputedStyle(
                              document.documentElement,
                            ).getPropertyValue('--success_48')}
                            className="status-icon-ready"
                          />
                        ) : driveDetails?.[index]?.status ==
                          constants.DRIVE_FAIL_STATUS ? (
                          <ExclamationCircle
                            size={20}
                            className="status-icon-not-ready"
                          />
                        ) : driveDetails?.[index]?.status ==
                          constants.DRIVE_NOT_INSTALLED_STATUS ? (
                          <XCircle
                            size={20}
                            className="status-icon-not-installed"
                          />
                        ) : driveDetails?.[index]?.status ===
                          constants.DRIVE_AT_RISK_STATUS ? (
                          <ExclamationCircle
                            size={20}
                            className="status-icon-at-risk"
                          />
                        ) : driveDetails?.[index]?.status ===
                            constants.DRIVE_FORMATTING_STATUS ||
                          driveDetails?.[index]?.driveState ===
                            constants.DRIVE_FORMATTING_STATUS ? (
                          <div class="lds-ring">
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                          </div>
                        ) : (
                          <XCircle
                            size={20}
                            className="status-icon-not-installed"
                          />
                        )}
                        <div
                          className="block-content"
                          style={{
                            marginTop:
                              driveDetails?.[index]?.status ===
                              constants.DRIVE_FORMATTING_STATUS
                                ? 5
                                : 0,
                          }}
                        >
                          {driveDetails?.[index]?.status
                            ? driveDetails?.[index]?.status ==
                              constants.DRIVE_READY_STATUS
                              ? 'Ready'
                              : driveDetails?.[index]?.status
                            : constants.DRIVE_NOT_INSTALLED_STATUS}
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <Row className="settings-block">
                    <Col>
                      <div className="hub-info-block-heading">
                        {constants.DEVICES_MANUFACTURER_TEXT}
                      </div>
                      <div className="hub-info-block-content">
                        {driveDetails?.[index]?.manufacturer
                          ? driveDetails?.[index]?.manufacturer
                          : '--'}
                      </div>
                    </Col>
                    <Col>
                      <div className="hub-info-block-heading">
                        {constants.DEVICES_MODEL_TEXT}
                      </div>
                      <div className="hub-info-block-content">
                        {driveDetails?.[index]?.model
                          ? driveDetails?.[index]?.model
                          : '--'}
                      </div>
                    </Col>
                  </Row>
                  <Row className="settings-block">
                    <Col>
                      <div className="hub-info-block-heading">
                        {constants.DEVICES_SERIAL_NO_TEXT}
                      </div>
                      <div className="hub-info-block-content">
                        {driveDetails?.[index]?.serialNumber
                          ? driveDetails?.[index]?.serialNumber
                          : '--'}
                      </div>
                    </Col>
                    <Col>
                      <div className="hub-info-block-heading">
                        {constants.DRIVE_CAPACITY_TEXT}
                      </div>
                      <div className="hub-info-block-content">
                        {driveDetails?.[index]?.totalCapacity
                          ? sizeConvertor(driveDetails?.[index]?.totalCapacity)
                          : '--'}
                      </div>
                    </Col>
                  </Row>
                </div>
              ))
          : ''}
      </div>

      {/* format drive- modal */}
      <SiteModal
        modalTitle={constants.DRIVE_FORMAT_TEXT}
        showModal={showFormatDriveModal}
        size="lg"
        hideModal={() => {
          setShowFormatDriveModal(false);
        }}
        classes="device-settings-driveinfo-modal"
      >
        <TextBlock
          className="drive-modal-confirm-text"
          fontWeight="700"
          fontSize="20px"
          lineHeight="28px"
        >
          {constants.DRIVE_FORMAT_CONFIRM_TEXT}
        </TextBlock>

        <PrimaryButton
          className="btn btn-primary-outline mb-2"
          type="button"
          width="100%"
          borderWidth="1.5px"
          hoverBorderWidth="1.5px"
          height="56px"
          fontSize="1.125rem"
          lineHeight="24px"
          onClick={() => {
            setShowFormatDriveModal(false);
          }}
        >
          {constants.UPDATE_FIRMWARE_CANCEL_BUTTON_LABEL}
        </PrimaryButton>

        <PrimaryButton
          className="btn btn-primary-outline text-capitalize mt-1"
          type="button"
          width="100%"
          borderWidth="1.5px"
          hoverBorderWidth="1.5px"
          height="56px"
          fontSize="1.125rem"
          lineHeight="24px"
          borderColor={getComputedStyle(
            document.documentElement,
          ).getPropertyValue('--error_64')}
          hoverBorderColor={getComputedStyle(
            document.documentElement,
          ).getPropertyValue('--error_64')}
          color={getComputedStyle(document.documentElement).getPropertyValue(
            '--error_64',
          )}
          hoverColor={getComputedStyle(
            document.documentElement,
          ).getPropertyValue('--brand_white')}
          hoverBackgroundColor={getComputedStyle(
            document.documentElement,
          ).getPropertyValue('--error_64')}
          backgroundColor="transparent"
          disabled={true}
          onClick={() => {
            formatDriveAction();
            setShowFormatDriveModal(false);
          }}
        >
          {constants.CONTINUE_TO_FORMAT_DRIVE_BUTTON}
        </PrimaryButton>
      </SiteModal>
      {/* format drive - modal */}
    </div>
  );
};

export default DriveInfoBlock;
